<template>
  <div>
    <el-divider content-position="left">{{ $t('receivablePayable.otherRules') }}</el-divider>

    <div class="feet-r">
      <!-- 增加一行 -->
      <el-button
        v-permit:remove="'btn:payable:quoteManagement:addEdit'"
        size="small"
        type="primary"
        @click="handleAdd"
      >{{ $t('basicData.AddAdditionalRules') }}</el-button>

      <!-- 下载/导入 -->
      <importAndDownloadCmp
        :business-type="businessType"
        :subregion-list="subregionList"
        :stitching-line="stitchingLine"
        :fee-list="specialFeeList"
        :get-data-func="onDownloadOffer"
        @importList="onImportList"
      />
      <!-- 清空报价 -->
      <el-popover placement="bottom-start" trigger="hover">
        <!-- 清空当前分区 -->
        <div class="feet">
          <el-button
            size="small"
            type="primary"
            @click="clearOffers(1)"
          >{{ $t('basicData.EmptyCurrentPartition') }}
          </el-button>
          <!-- 清空所有分区 -->
          <el-button
            class="feet-btn"
            size="small"
            type="primary"
            @click="clearOffers(2)"
          >{{ $t('basicData.EmptyAllPartitions') }}
          </el-button>
        </div>
        <!--清空报价-->
        <template #reference>
          <el-button
            size="small"
            plain
          >{{ $t('basicData.ClearTheOffer') }}
          </el-button>
        </template>
      </el-popover>
    </div>

    <!--没有选择分区 -->
    <TableCmp
      v-if="!partitionAffiliateId"
      ref="defaultTableRef"
      :fee-list="specialFeeList"
      :table-data="defaultPartitionObj.default.arr"
      @change="changeDefaultPartition"
    />

    <!--选择了分区 -->
    <TableCmp
      v-else
      ref="tableRef"
      :fee-list="specialFeeList"
      :table-data="getPartitionArr"
      @change="changePartition"
    />

  </div>
</template>

<script>
import { validatePrice, SEPARATOR } from './utils';
import { ROW_TMP } from './consts';

// 提交模板
const TEM_ROW = {
  'offerPriceId': undefined, // id 提交的时候需要
  'partitionId': null, // 分区id
  'partitionAffiliateId': null, // 分区关联id
  'feeTypeCode': 'PT022',
  'businessType': 0, // 业务类型
  'deliveryFeeRatio': 0.01,
  'specialRules': 1 // 暂时写死
};

export default {
  components: {
    TableCmp: () => import('./TableCmp.vue'),
    importAndDownloadCmp: () => import('./importAndDowloadCmp.vue')
  },

  props: {
    // 业务类型
    businessType: {
      type: [Number, String],
      required: true
    },
    // 报价id
    ids: {
      type: Number,
      default: 0
    },
    // 分区方案id
    partitionId: {
      type: [Number, String],
      default: () => {
        return 0;
      }
    },
    // 当前分区id/车线ID
    partitionAffiliateId: {
      type: [String, Number],
      default: ''
    },
    // 分区明细
    subregionList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 车线明细
    stitchingLine: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 特殊费用
    specialFeeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // table数据
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    return {
      // 如果没有选择分区
      defaultPartitionObj: {
        default: {
          arr: []
        }
      },

      // 如果选择了分区
      partitionObj: {
        // 分区id1: { arr: [] },
        // 分区id2: { arr: [] },
      }
    };
  },

  computed: {
    partitionComputed() {
      const a = this.partitionId;// 分区方案id
      const b = this.subregionList;// 所有子分区
      const c = this.stitchingLine; // 所有车线数据
      return {
        a, b, c
      };
    },

    getPartitionArr() {
      if (this.partitionAffiliateId) {
        return this.partitionObj[this.partitionAffiliateId]?.arr || [];
      }
      return [];
    }
  },

  watch: {
    // 监听分区/车线变化
    partitionComputed: {
      handler() {
        // 初始化
        this.dataCb();
      },
      deep: true,
      immediate: true
    },

    // 表格数据监听
    dataList: {
      async handler(val) {
        if (val.length === 0) { return; }
        await this.dataCb();
        await this.setData(val);
      },
      deep: true
      // immediate: true
    }
  },

  methods: {
    // 初始化分区
    dataCb() {
      // 直接替换对象而非逐个删除属性 提高性能
      this.partitionObj = {};

      if (!this.partitionId) {
        // 干支线业务
        if (this.partitionAffiliateId) {
          // 车线数据
          if (!this.stitchingLine.length) { return; }
          this.stitchingLine.forEach(item => {
            this.$set(this.partitionObj, item.id, {
              arr: []
            });
          });
        } else {
          // 未选择分区方案
          this.defaultPartitionObj.default.arr = [];
        }
        return;
      }
      // 存在分区方案ID，初始化分区明细
      if (!this.subregionList.length) { return; }
      this.subregionList.forEach(item => {
        this.$set(this.partitionObj, item.id, {
          arr: []
        });
      });

      console.log('dataCb236', this.partitionObj);
    },

    // 增加一行
    handleAdd() {
      if (!this.partitionId) {
        // 干支线业务
        if (this.partitionAffiliateId) {
          this.partitionObj[this.partitionAffiliateId].arr.push({ ...ROW_TMP });
        } else {
          // 未选择分区方案
          this.defaultPartitionObj.default.arr.push({
            ...ROW_TMP
          });
        }
        return;
      }

      // 选择了分区方案
      this.partitionObj[this.partitionAffiliateId].arr.push({ ...ROW_TMP });
    },

    // 默认分区
    changeDefaultPartition(arr) {
      this.defaultPartitionObj.default.arr = arr;
    },

    // 选择分区
    changePartition(arr = []) {
      if (arr.length === 0) { return; }
      this.partitionObj[this.partitionAffiliateId].arr = arr;
    },

    /**
     * 提交校验
     *    1. 直接校验当前分区
     *    2. 其他分区填写的数据校验
     */
    async submitForm() {
      // 无分区、车线
      if (!this.partitionId && !this.partitionAffiliateId) {
        // 无数据（非必填）
        if (this.defaultPartitionObj.default.arr.length === 0) {
          return true;
        }

        // 存在数据，校验必填项
        const isBool = await this.$refs.defaultTableRef.submitForm();
        if (!isBool) {
          this.$message.warning(this.$t('operatingPlatform.PleaseFillInTheRequiredFields'));
          return false;
        }
        return true;
      }

      // 选择了分区方案/车线方案
      {
        // 校验当前分区
        const isBool = await this.$refs.tableRef.submitForm();

        if (!isBool) {
          this.$message.warning(this.$t('basicData.CheckFail'));
          return false;
        }
      }
      // 存在其他分区，校验
      {
        const arr = [];
        for (const key in this.partitionObj) {
          const isBool = validatePrice(this.partitionObj[key].arr);
          if (!isBool) {
            arr.push(key);
          }
        }
        // 有校验不通过的分区
        const dataList = this.businessType === 5 ? this.stitchingLine : this.subregionList;
        if (arr.length > 0) {
          // 获取不通过的分区名称
          const list = dataList.filter(item => {
            return arr.includes(String(item.id));
          }).map(item => {
            return item.partitionIdentifier;
          }).join(',');

          this.$message.error('其他规则的关联分区《' + list + '》' + this.$t('basicData.CheckFail'));
          return false;
        }
      }
      return true;
    },

    // 设置数据(主要是为父组件提供操作)
    setData(arr) {
      console.log(arr, 'setData其他规则');
      if (arr.length === 0) { return; }
      try {
        if (!this.partitionId && !this.partitionAffiliateId) {
          // 无分区
          this.defaultPartitionObj.default.arr = arr.map(item => ({
            feeTypeCode: item.feeTypeCode || '',
            deliveryFeeRatio: item.deliveryFeeRatio || 0.01
          }));
          return;
        }
        // 选择了分区/车线方案
        for (const item of arr) {
          const { partitionAffiliateId, lineId } = item;
          const key = this.businessType === 5 ? lineId : partitionAffiliateId;
          // 排除无效键值
          if (!key) continue;
          if (!this.partitionObj[key]) {
            this.partitionObj[key] = { arr: [] };
          }
          this.partitionObj[key].arr.push(item);
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 获取数据
    getData() {
      const arr = [];
      if (!this.partitionId && !this.partitionAffiliateId) {
        // 未选择分区/车线方案
        return this.defaultPartitionObj.default.arr.map(item => {
          return {
            ...TEM_ROW,
            ...item,
            partitionAffiliateId: undefined,
            businessType: this.businessType
          };
        });
      }
      // 选择了分区/车线，将所有数据（二维数组）放入arr（一维数组）中
      Object.entries(this.partitionObj)
        .filter(([_, partition]) => partition.arr.length > 0)
        .forEach(([affiliateId, partition]) => {
          const list = partition.arr.map(item => ({
            ...TEM_ROW,
            ...item,
            offerPriceId: this.ids,
            partitionId: this.partitionId,
            partitionAffiliateId: affiliateId,
            businessType: this.businessType
          }));
          arr.push(...list);
        });

      console.log(arr, 'getData-other-395');
      return arr;
    },

    // 下载报价回调函数
    onDownloadOffer() {
      const list = this.getData();

      const buildMapById = (arr) => {
        const map = new Map();
        arr.forEach(item => {
          if (item && typeof item.id !== 'undefined') {
            map.set(item.id, item);
          }
        });
        return map;
      };

      const stitchingLineMap = buildMapById(this.stitchingLine);
      const subregionListMap = buildMapById(this.subregionList);

      const specialFeeMap = new Map();
      this.specialFeeList.forEach(fee => {
        if (fee && fee.code) {
          specialFeeMap.set(fee.code, fee);
        }
      });

      return list.map(item => {
        const { id, partitionAffiliateId, feeTypeCode, deliveryFeeRatio, startNumber, endNumber } = item;

        const obj = {
          id,
          partitionAffiliateId: '', // 分区关联id
          feeTypeCode: '', // 费用类型处理
          startNumber,
          endNumber,
          deliveryFeeRatio: deliveryFeeRatio || 0.01 // 计费规则
        };

        let targetMap;
        let convertedId;

        if (this.businessType === 5) {
          targetMap = stitchingLineMap;
          convertedId = String(partitionAffiliateId);
        } else {
          targetMap = subregionListMap;
          convertedId = Number(partitionAffiliateId);
          if (isNaN(convertedId)) {
            convertedId = null; // 明确无效数字处理
          }
        }

        // 处理分区/车线名称
        if (convertedId !== null && targetMap.has(convertedId)) {
          const partitionAffiliateObj = targetMap.get(convertedId);
          const { partitionIdentifier, id: pid, name } = partitionAffiliateObj || {};
          obj.partitionAffiliateId = `${partitionIdentifier || name || ''}${SEPARATOR}${pid}`;
        }

        // 费用类型处理
        if (specialFeeMap.has(feeTypeCode)) {
          const feeObj = specialFeeMap.get(feeTypeCode);
          obj.feeTypeCode = `${feeObj.name}${SEPARATOR}${feeTypeCode}`;
        }

        return obj;
      });
    },

    // 导入数据
    onImportList(arr) {
      console.log(arr, '导入数据-457');
      // 数据校验
      {
        const arr = [];
        for (const key in this.partitionObj) {
          const isBool = validatePrice(this.partitionObj[key].arr);
          if (!isBool) {
            arr.push(key);
          }
        }
        // 有校验不通过的分区
        const dataList = this.businessType === 5 ? this.stitchingLine : this.subregionList;
        if (arr.length > 0) {
          // 获取不通过的分区名称
          const list = dataList.filter(item => {
            return arr.includes(String(item.id));
          }).map(item => {
            return item.partitionIdentifier;
          }).join(',');

          this.$message.error('其他规则的关联分区《' + list + '》' + this.$t('basicData.CheckFail'));
          return false;
        }
      }
      // 选择分区校验
      // if (this.partitionId) {
      //   const isBool = arr.every(item => {
      //     const { partitionAffiliateId } = item;
      //     if (this.partitionObj[partitionAffiliateId]) {
      //       return true;
      //     }
      //     return false;
      //   });
      //
      //   if (!isBool) {
      //     //
      //     const str1 = this.$t('operationCenter.DownloadTheTemplate'); // 下载模板
      //     const str2 = this.$t('GlobalSetObj.pleaseChoose'); // 请选择
      //     const str3 = this.$t('operationCenter.partition'); // 分区
      //
      //     this.$message.warning(`${str1}${str2}${str3}`);
      //   }
      // }
      this.setData(arr);
    },

    /**
     * @description 清空报价
     * @param {Number} type 1:清空当前分区/车线 2:清空所有分区/车线
     */
    clearOffers(type) {
      if (type === 1 && Object.keys(this.partitionObj)?.length) {
        this.partitionObj[this.partitionAffiliateId].arr = [];
      } else {
        for (const key in this.partitionObj) {
          this.partitionObj[key].arr = [];
        }
      }
    }
  }
};
</script>

